import type { AppConfig } from './AppConfig.d.ts';

export function getConfig(): AppConfig {
  return window.globalConfiguration;
}
